<template>
  <div class="footer-content ml-4 mt-3">
    <b-row>
      <b-col v-if="brand === 'se'" cols="12" md="7">
        <b-img
          :src="seBrand.companyLogo1"
          alt="FVC Logo"
          height="40"
        />
        <div class="disclaimer-text mt-1">
        <p>Users of this service are bound by our Terms and Conditions and Disclaimer</p>
       <p>   <strong>About Structured Edge</strong></p>
          Structured Edge is the UK’s leading structured product platform. It is available to financial advisers and other professionals. It provides information and analysis on current products in the market, together with compliance and selection tools, product lifecycle data and portfolio metrics.
      <p></p> <p>   <strong>About FVC</strong></p>
     Future Value Consultants (FVC) has long-standing experience and expertise in structured products. It provides analytics services to investment banks, product providers and financial advisers, including stress testing, independent valuations and portfolio calculations.      </div>
      </b-col>
      <b-col v-if="brand === 'se'" cols="6" md="2">
        <h6 class="footer-section-title">Help</h6>
        <ul class="footer-links">
        <li v-if="$store.getters['auth/showPremiumUpgrade']">
            <b-link :to="{ name: 'learn-more-premium' }">
              <feather-icon icon="BookIcon" size="14" class="mr-50" />
              Upgrade to Premium
            </b-link>
          </li>
          <li>
            <b-link :to="{ name: 'guides' }">
              <feather-icon icon="BookOpenIcon" size="14" class="mr-50" />
              Structured Edge Guides
            </b-link>
          </li>
          <li>
            <b-link :to="{ name: 'terms-and-conditions' }">
              <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
              Terms & Conditions
            </b-link>
          </li>
          <li>
            <b-link :to="{ name: 'privacy-policy' }">
              <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
              Privacy Policy
            </b-link>
          </li>
          <li>
            <b-link :to="{ name: 'disclaimer' }">
              <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
              Disclaimer
            </b-link>
          </li>
        </ul>
      </b-col>
      <b-col v-if="brand === 'se'" cols="6" md="3">
        <h6 class="footer-section-title">Contact Us</h6>
        <ul class="footer-links">
          <li>
            <b-link :to="{ name: 'contact-us' }">
              <feather-icon icon="MessageSquareIcon" size="14" class="mr-50" />
              Enquiries and Feedback
            </b-link>
          </li>
          <li>
            <b-link href="https://www.futurevc.co.uk" target="_blank">
              <feather-icon icon="GlobeIcon" size="14" class="mr-50" />
              FVC Website
            </b-link>
          </li>
          <li>
            <b-link href="https://www.linkedin.com/company/future-value-consultants/" target="_blank">
              <feather-icon icon="LinkedinIcon" size="14" class="mr-50" />
              LinkedIn
            </b-link>
          </li>
          <li class="footer-address">
            <feather-icon icon="MapPinIcon" size="14" class="mr-50" />
22 Tideway Yard<br>125 Mortlake High Street<br>London, SW14 8SN, UK
          </li>
        </ul>
      </b-col>
      <b-col v-else :cols="12">
      </b-col>
    </b-row>
    <hr class="footer-divider mt-3">
    <p class="mb-0 mt-1 text-center">
      Copyright  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://www.futurevc.co.uk"
        target="_blank"
      >FVC</b-link>
      <span class="d-none d-sm-inline-block">, All rights reserved.</span>
    </p>
  </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
  BLink, BRow, BCol, BImg,
} from 'bootstrap-vue'
import BrandLogosMixin from '@/mixins/BrandLogosMixin.vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BLink,
    BRow,
    BCol,
    BImg,
    FeatherIcon,
  },
  mixins: [BrandLogosMixin],
  data() {
    return {
      brand: $themeConfig.app.brand,
    }
  },
}
</script>

<style lang="scss" scoped>
.footer-content {
  padding-left: 2rem;
  padding-right: 0rem;
}

.disclaimer-text {
  font-size: 0.875rem;
}

.footer-divider {
  margin: 1rem 0;
  border-top: 2px solid #ebe9f1;
}

.dark-layout .footer-divider {
  border-top-color: #3b4253;
}

.footer-section-title {
  margin-top: 1rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 1.05rem;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0.5rem;
    font-size: 0.95rem;

    a {
      color: inherit;
      text-decoration: none;
      display: inline-flex;
      align-items: center;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .footer-address {
    margin-top: 0.75rem;
    font-style: italic;
    display: flex;
    align-items: flex-start;
  }
}
</style>
